// src/hooks/products/useUpdateProduct.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateProduct } from "../../api/apiProducts";
import parseError from "../../utils/parseError";

const useUpdateProduct = (onSuccessCallback) => { // ✅ إضافة callback parameter
    const queryClient = useQueryClient();

    const {
        mutate: updateProductMutate, // ✅ تغيير الاسم من editProduct إلى updateProductMutate
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: ({ id, req }) => updateProduct(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["products"] });
            queryClient.invalidateQueries({ queryKey: ["product"] });

            // ✅ استدعاء callback إذا موجود
            if (onSuccessCallback) {
                onSuccessCallback();
            }
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update product");
        },
    });

    return {
        updateProductMutate, // ✅ تغيير الاسم
        isPending: isPending || isLoading, // ✅ توحيد الاسم
    };
};

export default useUpdateProduct;
